import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

/**
 * ChecklistItem document interface
 */
export interface ChecklistItemDocument extends BaseDocument {
  checklistId: string
  content: string
  isCompleted: boolean
  sortOrder: string
}

/**
 * ChecklistItem-specific hooks
 */
const hooks = createEntityHooks<ChecklistItemDocument>('checklistitems')

export const useChecklistItems = (
  filter?: Partial<ChecklistItemDocument>,
  options?: { enabled?: boolean },
) => {
  const { data, isLoading, db } = hooks.useEntities(filter, options)
  return { checklistItems: data, isLoading, db }
}

export const useChecklistItem = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { checklistItem: data, isLoading }
}

export const useChecklistItemMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createChecklistItem: create,
    updateChecklistItem: update,
    deleteChecklistItem: deleteEntity,
  }
}
